import { AccountStorageBalance } from '../../../types';
import { PlatformFeeAndAccounts } from './types';

const NO_PLATFORM_FEE: PlatformFeeAndAccounts = {
  feeBps: 0,
  feeAccountId: '',
  feeAccountTokens: new Map<string, AccountStorageBalance>(),
};

export { NO_PLATFORM_FEE };
